'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Redo = require('./Redo');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Redo).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Redo/index.js
// module id = 1272
// module chunks = 1